import get from 'lodash/get';

/**
 * Generic reducer - returns functions for each string in the props array that matches a property in the object.
 *
 * @param {String} path
 * @param {String} mutation
 * @param {Array} props
 *
 * @returns {Function}
 */
export function mapReducers(path, mutation, props) {
    return props.reduce((computed, prop) => ({
        ...computed,
        [prop]: {
            get() {
                return get(this, path)[prop];
            },

            set(value) {
                this.$store.commit(mutation, {
                    ...get(this, path),
                    [prop]: value,
                });
            },
        },
    }), {});
}
